// extracted by mini-css-extract-plugin
module.exports = {"block":"EgiftAgenda_block__xXnZw","list":"EgiftAgenda_list__cIa70"};